import React, { createContext, useContext, useState, useEffect } from "react";
import {
  login,
  register,
  verifyEmail,
  completeRegistration,
  getProfile,
  logout,
} from "../../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [loading, setLoading] = useState(true);

  const handleLogin = async (email, password) => {
    try {
      const data = await login(email, password); // Call the login API
      if (data.token) {
        setUser(data.user); // Update user state
        setToken(data.token); // Update token state
        localStorage.setItem("token", data.token); // Save token to localStorage
        console.log("Login successful");
        
      } else {
        throw new Error("No token received");
      }
    } catch (error) {
      console.error("Login failed:", error);
      throw error; // Re-throw the error so the caller can handle it
    }
  };

  const handleRegister = async (userData) => {
    const data = await register(userData);
    return data;
  };

  const handleVerifyEmail = async (tempUserId, otp, email) => {
    const data = await verifyEmail(tempUserId, otp, email);
    return data;
  };

  const handleCompleteRegistration = async (tempUserId, age) => {
    const data = await completeRegistration(tempUserId, age);
    setUser(data.user);
    setToken(data.token);
    localStorage.setItem("token", data.token);
  };

  const handleLogout = async () => {
    try {
      await logout(); // Call the logout API
      console.log("Logout successful");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setUser(null);
      console.log("User state set to null");
      setToken(null);
      console.log("Token state set to null");
      setLoading(false);
      console.log("Loading state set to false");
      localStorage.removeItem("token");
      console.log("Token removed from localStorage");
    }
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (token) {
        try {
          const result = await getProfile(token); // Fetch user profile
          setUser(result);
          console.log("User:", result);
        } catch (error) {
          console.error("Error fetching data:", error);
          handleLogout(); // Logout if the token is invalid
        } finally {
          setLoading(false); // Ensure loading is set to false
        }
      } else {
        setLoading(false); // No token, so no need to load
      }
    };

    fetchUserProfile();
  }, [token]); // Re-run when token changes

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "token") {
        if (event.newValue === null) {
          // Token was deleted
          setUser(null);
          setToken(null);
          setLoading(false);
        } else {
          // Token was added or updated
          setToken(event.newValue);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        login: handleLogin,
        register: handleRegister,
        verifyEmail: handleVerifyEmail,
        completeRegistration: handleCompleteRegistration,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);